import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import {baseUrl,} from "../Univ";
function Notification() {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        getNotifications();
    }, []);
    const getNotifications = () => {
        setLoading(true);
        axios
            .get(baseUrl + "notification/")
            .then((res) => {
                setNotifications(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire("Error", "Unable to load notifications", "error");
            });
    };
    const markRead = (id) => {
        axios
            .patch(`notification/${id}/`, {
                is_read: true
            })
            .then(() => {
                setNotifications(prev => prev.map(item => item.id === id ? {
                    ...item, is_read: true
                } : item));
            });
    };
    const deleteNotification = (id) => {
        Swal.fire({
            title: "Delete Notification?", icon: "warning", showCancelButton: true, confirmButtonText: "Delete"
        })
            .then((result) => {
                if (result.isConfirmed) {
                    axios
                        .delete(`notification/${id}/`)
                        .then(() => {
                            Swal.fire("Deleted", "Notification removed", "success");
                            getNotifications();
                        });
                }
            });
    };
    return (<div className="container-fluid mt-3">


        <div className="card shadow">


            <div className="card-header bg-primary text-white">


                <h5 className="mb-0">

                    🔔 Notifications

                </h5>


            </div>


            <div className="card-body">


                {loading && (<div className="alert alert-info">

                    Loading Notifications...

                </div>)}


                {notifications.length === 0 && !loading && (<div className="alert alert-warning">

                    No Notifications

                </div>)}


                <div className="row">


                    {notifications.map((item) => (<div

                        key={item.id}

                        className="col-lg-4 col-md-6 mb-4"

                    >


                        <div

                            className="card app-card shadow-sm"

                            style={{
                                backgroundColor: item.is_read ? "#ffffff" : "#fff3cd"
                            }}

                        >


                            <div className="app-card-header">


                                🔔 {item.title}


                            </div>


                            <div className="app-card-body">


                                <p>

                                    {item.message}

                                </p>


                                <p>

                                    <strong>
                                        Module:
                                    </strong>

                                    {" "}

                                    {item.module}

                                </p>


                                {item.document_type && (<p>

                                    <strong>
                                        Document:
                                    </strong>

                                    {" "}

                                    {item.document_type}

                                    {" #"}

                                    {item.document_id}

                                </p>)}


                                <small className="text-muted">

                                    {item.sent_at}

                                </small>


                            </div>


                            <div className="app-card-footer">


                                {!item.is_read && (<button

                                    className="btn btn-success w-100 mb-2"

                                    onClick={() => markRead(item.id)}

                                >

                                    ✅ Mark Read

                                </button>)}


                                {item.document_id && (<button

                                    className="btn btn-primary w-100 mb-2"

                                    onClick={() => {
                                        window.location.href = `/${item.module}/${item.document_id}`;
                                    }}

                                >

                                    Open

                                </button>)}


                                <button

                                    className="btn btn-danger w-100"

                                    onClick={() => deleteNotification(item.id)}

                                >

                                    Delete

                                </button>


                            </div>


                        </div>


                    </div>))}


                </div>


            </div>


        </div>


    </div>);
}
export default Notification;